module.exports = "/_next/static/images/319fc6e53c064c76209dae95de5b4502-blog-075x.jpg.webp";